import { mapActions, mapGetters, mapMutations } from 'vuex'
import Loading from '@/components/loading/index.vue'

export default {
  components: {
    Loading
  },
  props: {
    value: {
      required: true,
      type: Boolean
    }
  },
  data () {
    return {
      name: '',
      dialog: false,
      isLoading: false,
      changeBillet: ''
    }
  },
  computed: {
    ...mapGetters([
      'getterSelectedInvoice',
      'getterAccount'
    ])
  },
  mounted () {
    this.dialog = true

    if (this.getterSelectedInvoice.idBillet !== null) {
      this.changeBillet = this.getterSelectedInvoice.idBillet
    }
  },
  beforeDestroy () {
    this.SET_SELECTED_INVOICE()
  },
  methods: {
    ...mapActions([
      'actionUpdateBillet'
    ]),
    ...mapMutations([
      'SET_SELECTED_INVOICE'
    ]),
    changeIdBillet () {
      const params = {
        ...this.getterSelectedInvoice,
        idBillet: this.changeBillet.trim()
      }

      this.isLoading = true

      this.actionUpdateBillet(params)
        .then(() => {
          this.closeModal()

          this.sendToast({
            text: 'Identificador do boleto atualizado',
            type: 'success'
          })
        })
        .catch((error) => {
          this.isLoading = false

          if (error && error.response && error.response.data && error.response.data.data && error.response.data.data.name === 'IX_Invoice_IdBillet') {
            this.sendToast({
              text: 'Este identificador já existe em outro boleto',
              type: 'warning'
            })
          } else {
            this.sendToast({
              text: 'Ocorreu um erro ao atualizar o identificador do boleto',
              type: 'danger'
            })
          }
        })
    },
    closeModal () {
      this.isLoading = this.dialog = false

      setTimeout(() => {
        this.$emit('input', false)
      }, 300)
    }
  }
}
